import { supabaseClient } from '~/shared/common/supabase/client'
import { UserMeOutput, UserUpdateInput, UserUpdateOutput } from '~/shared/user/user.api.schema'
import type { User } from '~/shared/user/user.supabase.schema'

async function getAuthHeader(): Promise<string> {
  const {
    data: { session },
  } = await supabaseClient.auth.getSession()
  if (!session?.access_token) {
    throw new Error('Not authenticated')
  }
  return `Bearer ${session.access_token}`
}

export const fetchUserMe = async (): Promise<User> => {
  const res = await fetch('/api/user/me', {
    method: 'GET',
    headers: {
      Authorization: await getAuthHeader(),
    },
  })
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string }
    throw new Error(body.error ?? `/api/user/me ${res.status}`)
  }
  return UserMeOutput.parse(await res.json())
}

export const submitUserUpdate = async (input: UserUpdateInput): Promise<User> => {
  const res = await fetch('/api/user/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: await getAuthHeader(),
    },
    body: JSON.stringify(input),
  })
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string }
    throw new Error(body.error ?? `/api/user/update ${res.status}`)
  }
  return UserUpdateOutput.parse(await res.json())
}
